import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { Button } from '../ui/button';

const MobileNav = ({
  navItems,
  serviciosSubItems,
  isActive,
  mobileMenuOpen,
  setMobileMenuOpen,
  mobileServiciosOpen,
  setMobileServiciosOpen,
}) => (
  <div
    className={`md:hidden overflow-hidden transition-all duration-300 ${
      mobileMenuOpen ? 'max-h-[700px] opacity-100' : 'max-h-0 opacity-0'
    }`}
  >
    <nav className="py-4 border-t border-gray-200 space-y-1">
      {navItems.map((item) => {
        if (item.hasDropdown) {
          return (
            <div key={item.id}>
              <button
                type="button"
                onClick={() => setMobileServiciosOpen((v) => !v)}
                data-testid={`mobile-nav-${item.id}`}
                data-analytics-click={`mobile-nav-${item.id}`}
                className={`flex items-center justify-between w-full text-left px-4 py-3 rounded-lg transition-all duration-300 ${
                  isActive(item.path)
                    ? 'text-orange-500 bg-orange-500/10'
                    : 'text-gray-700 hover:text-orange-500 hover:bg-gray-100'
                }`}
                aria-expanded={mobileServiciosOpen}
              >
                <span>{item.label}</span>
                <ChevronDown
                  className={`w-4 h-4 transition-transform duration-300 ${
                    mobileServiciosOpen ? 'rotate-180' : ''
                  }`}
                />
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  mobileServiciosOpen ? 'max-h-60 mt-1' : 'max-h-0'
                }`}
              >
                <div className="bg-white/50 backdrop-blur-xl border border-white/30 rounded-xl mx-2 my-1">
                  {serviciosSubItems.map((sub) => (
                    <Link
                      key={sub.id}
                      to={sub.path}
                      onClick={() => {
                        setMobileMenuOpen(false);
                        setMobileServiciosOpen(false);
                      }}
                      data-testid={`mobile-nav-${sub.id}`}
                      data-analytics-click={`mobile-nav-${sub.id}`}
                      className={`block px-5 py-2.5 text-sm font-medium transition-all ${
                        isActive(sub.path)
                          ? 'text-orange-500'
                          : 'text-gray-800 hover:text-orange-500'
                      }`}
                    >
                      {sub.label}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          );
        }

        return (
          <Link
            key={item.id}
            to={item.path}
            onClick={() => setMobileMenuOpen(false)}
            data-testid={`mobile-nav-${item.id}`}
            data-analytics-click={`mobile-nav-${item.id}`}
            className={`block w-full text-left px-4 py-3 rounded-lg transition-all duration-300 ${
              isActive(item.path)
                ? 'text-orange-500 bg-orange-500/10'
                : 'text-gray-700 hover:text-orange-500 hover:bg-gray-100'
            }`}
          >
            {item.label}
          </Link>
        );
      })}
      <div className="pt-2 px-4">
        <Link to="/contacto" onClick={() => setMobileMenuOpen(false)}>
          <Button
            data-analytics-click="mobile-quote-btn"
            className="bg-orange-500 hover:bg-orange-600 text-white w-full"
          >
            Cotizar Ahora
          </Button>
        </Link>
      </div>
    </nav>
  </div>
);

export default MobileNav;
